import { Fragment } from 'react'
import { ChatBubbleLeftEllipsisIcon, TagIcon, UserCircleIcon } from '@heroicons/react/20/solid'
import { getHistory} from '../../../../data/followup/selectors/followup';
import { useSelector } from "react-redux";
import EntryContainer from "../../containers/history/EntryContainer";
import { useTranslation } from "react-i18next";
import InstantMessageFormContainer from "../../containers/history/InstantMessageFormContainer";

const HistoryEntryList = ({ entries }) =>
    <section className="actions-list">
        <InstantMessageFormContainer />

        {entries.map((entry, index) => {
            const isFirst = index == (entries.length - 1);
            const isLast = 0 == index;

            return (
                <EntryContainer key={index} isFirst={isFirst} isLast={isLast} {...entry} />
            );
        })}
    </section>
;

function getUnreadMessagesText(count, t) {
    if (count == 1) {
        return count + ' ' + t('followup.new_message');
    }

    if (count > 1) {
        return count + ' ' + t('followup.new_messages');
    }

    return null;
}

export default function Feed() {

    const history = useSelector(state => getHistory(state.followup))
    const {t} = useTranslation();

    return (
        <div className="flow-root">
            <h2 className="mb-10 font-bold">{t('followup.demand_historical')} :</h2>
            {(history.unreadMessages > 0) && getUnreadMessagesText(history.unreadMessages, t)}
            <ul role="list" className="-mb-8">
                <InstantMessageFormContainer />

                {history.entries.map((entry, index) => {
                    const isLast = index == (history.entries.length - 1);
                    return <EntryContainer isLast={isLast} key={index} {...entry} />
                })}
            </ul>
        </div>
    )
}